import { useTranslation } from "react-i18next";
import { Skeleton } from "@h2j-data-team/ui";

/**
 * Placeholder for the capacity screen while there is nothing to show yet —
 * either the first load or the very first collection. It traces the real
 * layout: the gauge card (eyebrow, big number, bar, legend) and the tabbed
 * ranking card.
 */
export function CapacitySkeleton() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col gap-5" aria-busy>
      <p role="status" className="sr-only">
        {t("list.loading")}
      </p>
      <div className="flex flex-col gap-4 rounded-xl border border-hairline bg-surface px-5 py-4">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="min-w-0 space-y-2">
            <Skeleton className="h-3 w-44" />
            <Skeleton className="h-8 w-52" />
            <Skeleton className="h-3 w-28" />
          </div>
          <Skeleton className="h-4 w-40" />
        </div>

        <Skeleton className="h-2.5 w-full rounded-full" />

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="h-3 w-36" />
          ))}
        </div>

        <Skeleton className="h-3 w-56" />
      </div>

      <div className="overflow-hidden rounded-xl border border-hairline bg-surface">
        <div className="flex gap-6 border-b border-hairline px-5 pb-2.5 pt-3.5">
          <Skeleton className="h-3.5 w-16" />
          <Skeleton className="h-3.5 w-20" />
          <Skeleton className="h-3.5 w-14" />
        </div>
        <div className="flex flex-col gap-4 px-5 py-4">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="flex items-center gap-4">
              <Skeleton className="h-3.5 flex-1" />
              <Skeleton className="h-3.5 w-24" />
              <Skeleton className="h-3.5 w-16" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
